<template>
  <div class="container bg-transparent mt-3 py-1">
    <div></div>
  </div>
</template>

<script>
/**
 * Ce fichier sert uniquement lors de la redirection après auth via APIM
 */
export default {
  name: "LoginApim",
};
</script>